module.exports = __webpack_public_path__ + "static/media/workfolio-big.c87b843c.png";